/** Passed via react-router location.state when opening a row from global search. */
export type SearchColumnFilter = {
  field: string
  /** Value typed in the search box */
  value: string
  /** Full cell value from search API (for select/relation filters) */
  matchingValue?: string
}

export type CollectionSearchNavigationState = {
  highlightUid?: string | null
  searchColumnFilter?: SearchColumnFilter
}

export function buildCollectionSearchNavigationState(options: {
  highlightUid?: string | null
  matchingField?: string | null
  matchingValue?: string | null
  searchQuery?: string
}): CollectionSearchNavigationState | undefined {
  const highlightUid = options.highlightUid ?? null
  const field = String(options.matchingField ?? "").trim()
  const value = String(options.searchQuery ?? "").trim()
  const matchingValue = String(options.matchingValue ?? "").trim()

  const searchColumnFilter =
    field && value ? { field, value, ...(matchingValue ? { matchingValue } : {}) } : undefined

  if (!highlightUid && !searchColumnFilter) return undefined
  return {
    ...(highlightUid ? { highlightUid } : {}),
    ...(searchColumnFilter ? { searchColumnFilter } : {}),
  }
}
